import React from "react";

function Range(props) {
    const percentRange = props.percentRange || 0;
    const width = percentRange <= 0?0:percentRange <= 100?percentRange: 100;
    return (
        <div className="progress-bar-range" style={{width: `${width}%`}}/>
    );
}

export default Range;